import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { styled } from "@mui/system";
import Button from "@mui/material/Button";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useNetworkStatus } from "../hooks/useNetworkStatus";
import { useScrollEdges } from "../hooks/useScrollEdges";
import { Container, Typography } from "@mui/material";

const LayoutWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  minHeight: "100dvh",
  width: "100%",
});

const MainContent = styled("div")({
  display: "flex",
  flexGrow: 1,
});

const ScrollButtonContainer = styled("div")({
  position: "fixed",
  bottom: "20px",
  left: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "20px",
  zIndex: 1000,
});

const ScrollButton = styled(Button)({
  fontSize: "16px",
  cursor: "pointer",
  background: "transparent",
  border: "none",
  color: "#333",
});

const ScrollToBottomButton = styled(ScrollButton)({
  width: "60px",
  height: "60px",
  background: "#2196F3",
  borderRadius: "50%",
  color: "#fff",
  "&:hover": {
    backgroundColor: "#1976D2",
  },
});

const ScrollToTopButton = styled(ScrollButton)({
  width: "60px",
  height: "60px",
  background: "#2196F3",
  borderRadius: "50%",
  color: "#fff",
  "&:hover": {
    backgroundColor: "#1976D2",
  },
});

const ScrollLayout = ({ children }) => {
  const isOnline = useNetworkStatus();

  const { atTop, nearTop, nearBottom } = useScrollEdges();
  const showToTop = !nearTop;
  const showToBottom = !atTop && !nearBottom;

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  return (
    <LayoutWrapper>
      <Header />
      {isOnline ? (
        <MainContent>{children}</MainContent>
      ) : (
        <Container
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            flexGrow: 1,
            color: "red",
          }}
        >
          <Typography variant='h6'>
            You are currently offline. Please check your internet connection.
          </Typography>
        </Container>
      )}
      <Footer />
      <ScrollButtonContainer>
        {showToTop && (
          <ScrollToTopButton onClick={scrollToTop}>
            <KeyboardArrowUpIcon fontSize='large' />
          </ScrollToTopButton>
        )}
        {showToBottom && (
          <ScrollToBottomButton onClick={scrollToBottom}>
            <KeyboardArrowDownIcon fontSize='large' />
          </ScrollToBottomButton>
        )}
      </ScrollButtonContainer>
    </LayoutWrapper>
  );
};

export default ScrollLayout;
